<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Billing',
      breadcrumb: {
        name: 'Billing',
        route: { name: 'billing' }
      },
      sidebar: [
        {
          icon: ['fal', 'chart-line'],
          route: { name: 'billing-dashboard' },
          name: 'Dashboard'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_invoicing_invoices'),
          icon: ['fal', 'file-invoice-dollar'],
          route: { name: 'billing-invoices' },
          name: 'Invoices' // invoice list + generate button in top right (which calls another iframe)
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_invoicing_generateInvoices'),
          icon: ['fal', 'layer-plus'],
          route: { name: 'billing-generate' },
          name: 'Generate Invoice'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_invoicing_reconciliation'),
          icon: ['fal', 'file-invoice'],
          route: { name: 'billing-reconciliation' },
          name: 'Reconciliation'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_invoicing_invoices'),
          icon: ['fal', 'file-invoice'],
          route: { name: 'billing-carrier' },
          name: 'Carrier Invoices' // should have import button on top (for sheep) + iframe from slack
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_invoicing_manageCredits'),
          icon: ['fal', 'credit-card'],
          route: { name: 'billing-credits' },
          name: 'Carrier Credits'
        },
        {
          hidden: true,
          icon: ['fal', 'file-invoice'],
          route: { name: 'billing-carrier-old' },
          name: 'Carrier Invoices' // should have import button on top (for sheep) + iframe from slack
        }
      ]
    }
  }
}
</script>
